import { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'
import { useSelector, useDispatch } from 'react-redux';
import { pdfjs } from 'react-pdf';

import Header from "./Header/Header";
import HomePage from "./Home/HomePage";
import AuthPage from "./Auth/AuthPage";
import AuthRedirect from "./Auth/AuthRedirect";
import AuthFill from "./Auth/AuthFill";
import AuthSignup from "./Auth/AuthSignup";
import AuthVerify from "./Auth/AuthVerify";
import AuthToVerify from "./Auth/AuthToVerify";
import AuthReset from "./Auth/AuthReset";
import SettingPage from "./Setting/SettingPage";
import SparePage from "./Spare/SparePage";
import AdminPage from "./Admin/AdminPage";
import AdminTroublePage from "./AdminTrouble/AdminTroublePage";
import AdminProcessPage from "./AdminProcess/AdminProcessPage";
import BrandPage from "./Brand/BrandPage";
import AdminProductPage from "./AdminProduct/AdminProductPage";
import AdminProductMenu from "./AdminProductMenu/AdminProductMenu";
import ProductFilePage from "./ProductFile/ProductFilePage";
import TroubleshootPage from "./Troubleshoot/TroubleshootPage";
import TroubleshootProcess from "./Troubleshoot/TroubleshootProcess";
import TroubleshootVirtual from "./Troubleshoot/TroubleshootVirtual";
import ReportPage from "./Report/ReportPage";
import ProcessLogPage from "./ProcessLog/ProcessLogPage";
import ProcessFilePage from "./ProcessFile/ProcessFilePage";
import ContactPage from "./Contact/ContactPage";
import UserPage from "./User/UserPage";
import AuthVersion from "./Auth/AuthVersion";
import WarrantyPage from "./Warranty/WarrantyPage";
import TroubleshootProduct from "./Troubleshoot/TroubleshootProduct";
import TroubleshootFile from "./Troubleshoot/TroubleshootFile";
import AuthForgot from "./Auth/AuthForgot";
import AuthForgotReset from "./Auth/AuthForgotReset";
import PrivacyPage from "./Privacy/PrivacyPage";
import DeletePage from "./Delete/DeletePage";
import ProductFileViewer from "./ProductFile/ProductFileViewer";

import PrivateRoutes  from "./PrivateRoutes";
import useMount from "../hooks/useMount";
import AlertModal from "./Commons/AlertModal";
import { getLabel } from "../tools/Dictionary";
import Global from "../Global/Global";
import ErrorComponent from "./Error/ErrorComponent";

import languageApi from "../api/languageApi";
import versionApi from "../api/versionApi";

import { getAuth } from "../slices/authSlice";
import { setLanguages } from "../slices/languageSlice";

import './App.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs`;


function App() {

  //Redux
  const auth = useSelector(getAuth); 
  const Dispatch = useDispatch();


  //Affichage
  const IsDesktop = useMediaQuery({
    query: `(min-width: 700px)`
  });

  //state
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useMount(() =>
  {

    loadData();

  }, []);

  const loadData = async () =>
  {

    try{



      const [versionResponse, languageResponse] = await Promise.all([
        versionApi.getVersion(),
        languageApi.getLanguage()
      ]);


      if (!languageResponse.Success)
      {
        let error = new Error()
        error.message = languageResponse.Error && languageResponse.Error.component ? getLabel(languageResponse.Error.component, languageResponse.Error.label) : undefined;

        throw error;
      }   

      Dispatch(setLanguages(languageResponse.Data));


      if (!versionResponse.Success)
      {
        let error = new Error()
        error.message = versionResponse.Error && versionResponse.Error.component ? getLabel(versionResponse.Error.component, versionResponse.Error.label) : undefined;

        throw error;
      }


      Global.appVersion = versionResponse.Data;

    }catch(err){



      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });



    }


  };

  
  
  return (
    <Router>
      <ErrorComponent />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
  
      {auth.isAuth &&
            <Header IsDesktop={IsDesktop} />
      }
      <div className="app_container">
        <Routes>
          <Route element={ <PrivateRoutes type={"isAuth"} auth={auth} /> } >
            <Route exact path={`/`} element={<HomePage IsDesktop={IsDesktop} />}  />
            <Route exact path={`/troubleshoot`} element={<TroubleshootPage IsDesktop={IsDesktop} />} />
            <Route path={`/troubleshoot/product`} element={<TroubleshootProduct IsDesktop={IsDesktop} />} />
            <Route path={`/troubleshoot/product/file`} element={<TroubleshootFile IsDesktop={IsDesktop} />} />
            <Route path={`/troubleshoot/product/process`} element={<TroubleshootProcess IsDesktop={IsDesktop} />} />
            <Route path={`/troubleshoot/product/virtual`} element={<TroubleshootVirtual IsDesktop={IsDesktop} />} />
            <Route exact path={`/setting`} element={<SettingPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/spare`} element={<SparePage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration`} element={<AdminPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/product`} element={<AdminProductMenu IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/product/product`} element={<AdminProductPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/product/file`} element={<ProductFilePage IsDesktop={IsDesktop} />} />
            <Route path={`/administration/user/*`} element={<UserPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/user`} element={<UserPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/brand`} element={<BrandPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/troubleshoot`} element={<AdminTroublePage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/troubleshoot/process`} element={<AdminProcessPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/troubleshoot/file`} element={<ProcessFilePage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/troubleshoot/report`} element={<ReportPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/administration/troubleshoot/log`} element={<ProcessLogPage IsDesktop={IsDesktop} />} />
            
            <Route path={`/contact`} element={<ContactPage IsDesktop={IsDesktop} />} />
            <Route exact path={`/warranty`} element={<WarrantyPage IsDesktop={IsDesktop} />} />
            
            
          </Route>
          <Route element={<PrivateRoutes type={"needFill"} auth={auth} />} >
            <Route exact path={`/auth/fill`} element={<AuthFill IsDesktop={IsDesktop} />} />
          </Route>
          <Route element={<PrivateRoutes type={"toVerify"} auth={auth} />} >
            <Route path={`/auth/toverify`} element={<AuthToVerify IsDesktop={IsDesktop} />} />
          </Route>
          <Route element={<PrivateRoutes type={"resetPassword"} auth={auth} />} >
            <Route path={`/auth/reset`} element={<AuthReset IsDesktop={IsDesktop} />} />
          </Route>
          <Route path={`/auth/redirect/google`} element={<AuthRedirect IsDesktop={IsDesktop} />} />
          <Route path={`/auth/redirect/azure`} element={<AuthRedirect IsDesktop={IsDesktop} />} />
          <Route path={`/auth/signup`} element={<AuthSignup IsDesktop={IsDesktop} />} />
          <Route path={`/auth/verify`} element={<AuthVerify IsDesktop={IsDesktop} />} />
          <Route path={`/auth/version`} element={<AuthVersion IsDesktop={IsDesktop} />} />
          <Route path={`/auth/forgot/reset`} element={<AuthForgotReset IsDesktop={IsDesktop} />} />
          <Route path={`/auth/forgot`} element={<AuthForgot IsDesktop={IsDesktop} />} />
          <Route path={`/auth/:path`} element={<AuthPage IsDesktop={IsDesktop} />} />
          <Route path={`/auth`} element={<AuthPage IsDesktop={IsDesktop} />} />
          <Route path={`/privacy`} element={<PrivacyPage IsDesktop={IsDesktop} />} />
          <Route exact path={`/delete`} element={<DeletePage IsDesktop={IsDesktop} />} />
          <Route path={`/productfile/viewer/:id`} element={<ProductFileViewer IsDesktop={IsDesktop} />} />
          

        </Routes>
      </div>
    </Router>
  );
}

export default App;
